import React, { useState, useEffect, useCallback } from "react";
import CoachLayout from "./common/CoachLayout";
import { CoachHeader } from "./common/CoachHeader";
import { useCoachAuthContext } from "./login/useCoachAuthContext";
import API_URL from '../api/API';

export const CoachMessages = () => {
  const { coach } = useCoachAuthContext();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [messageToDelete, setMessageToDelete] = useState(null);


  const fetchMessages = useCallback(async () => {
    if (coach) {
      try {
        const response = await fetch(API_URL.GET_AMAX_REPLIES_TO_COACH + coach.id, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${coach.token}`,
          },
        });
        const data = await response.json();
        if (response.ok) {
          setMessages(data);
        } else {
          throw new Error(data.error || "Failed to fetch messages");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
  }, [coach]);

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  const handleDeleteClick = (messageId) => {
    setShowConfirm(true);
    setMessageToDelete(messageId);
  };

  const confirmDelete = async () => {
    try {
      const response = await fetch(`${API_URL.DELETE_COACH_AMAX_REPLY}${messageToDelete}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${coach.token}`,
        },
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.error || "Failed to delete message");
      }
      setMessages(messages.filter((message) => message._id !== messageToDelete));
    } catch (err) {
      setError(err.message);
    } finally {
      setShowConfirm(false);
      setMessageToDelete(null);
    }
  };

  return (
    <div className="bg-white min-h-screen">
      <CoachLayout>
        <div className="bg-white min-h-full">
          <CoachHeader />
          <div className="container mx-auto p-6">
            <h2 className="text-2xl font-bold mb-4">Messages</h2>
            {error && <p className="text-red-500 mb-4">{error}</p>}
            {loading ? (
              <p>Loading messages...</p>
            ) : messages.length === 0 ? (
              <p>No messages available.</p>
            ) : (
              <div className="max-h-[500px] overflow-y-auto border border-gray-200 rounded-lg">
                <ul className="divide-y divide-gray-300">
                  {messages.map((message) => (
                    <li key={message._id} className="py-4 flex justify-between px-4">
                      <div>
                        <p className="text-sm font-semibold">AMAX Staff</p>
                        <p className="text-gray-700">{message.message}</p>
                        <p className="text-xs text-gray-500">
                          {new Date(message.timestamp).toLocaleString()}
                        </p>
                      </div>
                      <button
                        onClick={() => handleDeleteClick(message._id)}
                        className="text-red-600 hover:underline"
                      >
                        Delete
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}
            {showConfirm && (
              <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center">
                <div className="bg-white p-6 rounded-lg shadow-lg max-w-sm w-full">
                  <p className="text-lg font-semibold mb-4">Are you sure you want to delete this message?</p>
                  <div className="flex justify-end space-x-4">
                    <button
                      onClick={() => setShowConfirm(false)}
                      className="bg-gray-300 hover:bg-gray-400 text-black font-semibold py-2 px-4 rounded"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={confirmDelete}
                      className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </CoachLayout>
    </div>
  );
};
